import React from "react";
import { Button } from "react-bootstrap";
import "./Common_Btn.css";
function Common_Btn({ btnText, onClick }) {
  return (
    <div className="Common-buttons">
      <button className="submit-btn" onClick={onClick}>
        {btnText}
      </button>
    </div>
  );
}

export default Common_Btn;
